import { cn } from '@lyearn/style';
import { FormControlLabel, Radio } from '@lyearn/ui';

interface RadioCompProps {
  labelClassName?: string;
  className?: string;
  label?: string;
  value: string;
  disabled?: boolean;
}

const DEFAULT_CLASSES = {
  label: 'body-short-01',
};

function RadioComp(props: RadioCompProps) {
  const { labelClassName, className, label, value, disabled } = props;
  const formControlClasses = labelClassName
    ? {
        label: labelClassName,
      }
    : DEFAULT_CLASSES;

  return (
    <FormControlLabel
      classes={formControlClasses}
      control={<Radio className={cn('mx-12 my-10', className)} size="small" />}
      disabled={disabled}
      label={label!}
      value={value}
    />
  );
}

export default RadioComp;
